import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BatteryLow, ShieldAlert, CreditCard } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: BatteryLow,
    title: 'Cansancio Extremo',
    description: 'Trabajas 14 horas al día operando tu negocio, sin tiempo para escalar ni disfrutar los frutos de tu esfuerzo.'
  }, {
    icon: ShieldAlert,
    title: 'Miedo al IRS',
    description: 'Vives con la incertidumbre de no tener tu estructura legal y contable en orden, arriesgando tu patrimonio personal.'
  }, {
    icon: CreditCard,
    title: 'Cero Crédito Business',
    description: 'Mezclas finanzas personales con las del negocio y los bancos te niegan capital para crecer por falta de historial comercial.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-8 md:py-14 bg-gradient-to-b from-slate-50 to-slate-100" data-id="element-124">
      <div className="max-w-6xl mx-auto px-4" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-126">
          <h2 className="text-3xl md:text-4xl text-navy mb-4" data-id="element-127">
            ¿Te Identificas con Esto?
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-128" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-129">
          {problems.map((problem, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white p-8 rounded-xl shadow-lg border border-slate-200 hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center" data-id="element-130">
              <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6" data-id="element-131">
                <problem.icon className="w-8 h-8 text-navy" data-id="element-132" />
              </div>
              <h3 className="text-xl text-navy mb-3" data-id="element-133">{problem.title}</h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-134">
                {problem.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}